import React from 'react';
import BusComponent from './BusComponent';
import AppConfig from "../appConfig";
import { injectIntl } from "react-intl";

class ErrorPopup extends BusComponent {

    onReload = () => {
        window.location.reload()
    };

    render() {
        const { intl, originalError, additionalInfo } = this.props;

        const subject = intl.formatMessage({ id: 'emailSupportSubject' });
        const mailto = `mailto:${AppConfig.constants.supportEmail}?subject=${encodeURIComponent(subject)}`;

        return (
            <div className="error">
                <img
                    src={`${AppConfig.constants.assetsBaseURL}/svg/empty-box.svg`}
                    alt="Empty box image"
                />
                <div className="error-content">
                    <div className="title">
                        <h2>
                            {intl.formatMessage({ id: 'oopsSomethingWentWrong' })}
                        </h2>
                        <span>
                            {intl.formatMessage({ id: 'pleaseTryReloadingThePage' })}
                        </span>
                    </div>
                    <div className="error-text">
                        <div className="info">Error: <span>{originalError}</span></div>
                        {additionalInfo && (<div className="info">Additional info: <span>{additionalInfo}</span></div>)}
                    </div>
                    <button onClick={this.onReload}>
                        <span> {intl.formatMessage({ id: 'reload' })} </span>
                    </button>
                    <div className="error-footer">
                        <span>
                            If this issue persists, please reach out to us at <a href={mailto}>{AppConfig.constants.supportEmail}</a> with a screenshot of this page.
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(ErrorPopup);

